import styled from "styled-components"

export const Wrapper = styled.form`
    width: 100%;
    height: auto;
    .btns{
        margin-right:0px !important
    }
`